/* Meta's ViewContent through Upstack Data, sent from the theme (Matt, 2026-10-16).

   The Upstack app embed (config/settings_data.json, "upstack-data-tracking-pixel") defines
   window._upstack on every storefront page, and Upstack sends what it is given to Meta as both the
   browser event and the Conversions API copy. Its Customer events pixel only forwards Shopify's own
   events (product_viewed and so on), so a view that Shopify does not see is sent from here: a pack
   count settling (assets/st-track.js), a platform switch (assets/st-platform-swap.js) and a product
   or pack in the quiz funnel (assets/st-funnel.js). Same call and item shape as the Fittr Nutrition
   theme (docs/UPSTACK-TRACKING.md there).

     window.stUpstackView({ productId, title, currency, value, items: [{ variant, quantity, price, label }] })

   An item's name is its own name if given, else the product title and the pack label ("Google Review
   Card - 5 Cards"), so each product's packs can be told apart in Meta and Google.

   value and price are in the currency's units (22.94), not cents; currency is the buyer's. Without the
   app embed it does nothing. */
window.stUpstackView = (view) => {
  try {
    if (typeof window._upstack !== 'function' || !view?.items?.length) return;
    const currency = view.currency || '';
    window._upstack('track', 'view_content', {
      value: view.value,
      currency,
      items: view.items.map((it) => ({
        id: String(it.productId || view.productId || ''),
        variant: String(it.variant),
        name: it.name || [view.title, it.label].filter(Boolean).join(' - '),
        sku: String(it.variant),
        price: it.price,
        quantity: it.quantity || 1,
        currency,
      })),
    });
  } catch (err) {}
};
